<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
      v-if="isShow"
    >
      <el-form-item label="标题:" prop="activities_name">
        <el-input
          v-model="form.activities_name"
          placeholder="长度不能超过50"
        ></el-input>
      </el-form-item>
      <el-form-item label="标题简称:" prop="abbreviation">
        <el-input
          v-model="form.abbreviation"
          placeholder="长度在7~11字符之间记得算上标点符号呦！"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否标红:" prop="mark_red">
        <el-radio-group v-model="form.mark_red">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="封面:" prop="activities_logo">
        <uploadImage
          @setImgFun="getImgUrl"
          :fileListArr.sync="row.activities_logo"
        ></uploadImage>
      </el-form-item>

      <el-form-item label="摘要:">
        <el-input v-model="form.activities_summary"></el-input>
      </el-form-item>
      <el-form-item label="经销商:">
        <el-input v-model="form.activities_addr"></el-input>
      </el-form-item>
      <el-form-item label="活动时间:" prop="timeArr">
        <el-date-picker
          v-model="timeArr"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="热门活动:" prop="activities_hot">
        <el-radio-group v-model="form.activities_hot">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="阅读量:">
        <el-input v-model="form.activities_summary"></el-input>
      </el-form-item>
      <el-form-item label="点赞人数:">
        <el-input v-model="form.activities_summary"></el-input>
      </el-form-item> -->
      <el-form-item label="活动内容:" prop="activities_con">
        <myEditor @emitedit="onemitedit" :isactivitiesCon="activcon"></myEditor>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="onSubmit()">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadImage from "../../components/upload-image/upload-image";
import myEditor from "../../components/editor/editor";
import {AllEdit} from "../../api/api"
export default {
  components: {
    uploadImage,
    myEditor,
  },
  name: "car-activities-form",
  props: {
    layerid: String,
    edit: Boolean,
    keyword: Array,
    row: {
      default: function () {
        return [];
      },
    },
    types: Array,
  },
  data() {
    let data = {
      bt: "创建",
      headers: {}, // 文件上传header
      uploadUrl: "file-upload-set", // 文件上传url
      fileList: [], // 文件上传列表
      urlPath: { path: "" }, // 文件上传url对象
      form: { activities_type: 0 },
      loading: true,
      rules: {
        brandid: [{ required: true, message: "请选择车系", trigger: "change" }],
        activities_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      timeArr: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      options: [
        {
          value: "资讯",
          label: "资讯",
        },
        {
          value: "活动",
          label: "活动",
        },
      ],
      activcon: "",
      isShow:false
    };
    return data;
  },
  mounted() {},
  async created() {
    if (this.edit) {
      let msg = await AllEdit("api/car-activities/"+this.row.id);
      let {data} = msg;
      data = JSON.parse(data).data;
      this.form = data;
      this.timeArr = [
        this.form.activities_start_time,
        this.form.activities_end_time,
      ];
      this.activcon = this.form.activities_con
      this.isShow = true;
      this.loading = false;
    }else{
      this.isShow = true;
      this.loading = false;
    }
  },
  methods: {
    onSubmit() {
      if (!this.form.activities_name || !this.form.abbreviation) {
        this.$message.error("活动内容不能为空！！！");
        return;
      }
      if (
        //this.form.abbreviation.length < 7 ||
        this.form.abbreviation.length > 11
      ) {
        this.$message.error("标题简称不能大于11个字！！！");
        return;
      }
      if (this.form.activities_con == '') {
        this.$message.error("活动内容不能为空！！！");
        return;
      }
      this.form.activities_start_time = this.timeArr[0];
      this.form.activities_end_time = this.timeArr[1];
      this.$emit("carActivities", { form: this.form });
    },
    close() {
      this.$emit("carActivities", {});
    },
    dateConversion(timestamp) {
      if (timestamp == "" || typeof timestamp == "undefined") return "";
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // console.log()
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();

      function addZero(val) {
        return val < 10 ? "0" + val : val;
      }
      return (
        Y +
        "-" +
        addZero(M) +
        "-" +
        addZero(D) +
        " " +
        addZero(h) +
        ":" +
        addZero(m) +
        ":" +
        addZero(s)
      );
    },
    onemitedit(con) {
      //console.log('子组件传的值：',e);
      this.form.activities_con = con;
    },
    getImgUrl(e) {
      console.log("子组件传的值：", e);
      this.form.activities_logo = JSON.stringify(e); //上传文件列表
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>